import { webTypeApiUrl } from "@/constants/webTypeApiUrl";

export const ChatContainerHandler = {
  OpenURL: function (url) {
    window.open(url);
  },

  //檢查聊天室Token
  CheckToken: function (token) {
    var valid = false;
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRM/CheckToken",
      type: "get",
      async: false,
      data: { token: token },
      dataType: "json",
      success: function (data) {
        if (!data.Success) {
          alert(data.DisplayMessage);
        } else {
          valid = true;
        }
      },
      error: function (a, b, c) {
        window.location.href = "/#/Error";
      }
    });

    return valid;
  },

  //聊天訊息搜尋文字訊息
  SearchKeyWord: function (roomId, staffId, keyword) {
    var message = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Chat/SearchKeyWord",
      type: "post",
      async: false,
      data: {
        roomId: roomId,
        keyword: keyword,
        staffId: staffId
      },
      dataType: "json",
      success: function (data) {
        message = data
      },
      error: function (a, b, c) {
      }
    });
    return message;
  },
  //聊天訊息搜尋上下文
  GetMessagesByMessageId: function (roomId, messageId, sort, staffId) {
    var message = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Chat/GetMessagesByMessageId",
      type: "post",
      async: false,
      data: {
        roomId: roomId,
        messageId: messageId,
        sort: sort,
        fetchCount: 10,
        staffId: staffId
      },
      dataType: "json",
      success: function (data) {
        message = data
      },
      error: function (a, b, c) {
      }
    });
    return message;
  },

  GeneralChatRoomUrl: function (chatRoomId, staffId) {
    var chaturl = "";
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Friend/GeneralChatRoomUrl",
      type: "post",
      cache: false,
      async: false,
      data: {
        chatRoomId: chatRoomId,
        staffId: staffId
      },
      success: function (data) {
        chaturl = data;
      }
    });    
    return chaturl;
  }
};



// WEBPACK FOOTER //
// ./src/handler/ChatContainerHandler.js